<template>
    <div class="about-us">
        <div class="img-box">
            <img src="../assets/img/aboutus1.png" alt="">
            <img src="../assets/img/about2.png" alt="">
        </div>
        <div class="text-box">
            <p>北门影视文化创意工作室，初创于2011年8月，最初为编剧个人工作室。2014年10月开始公司化运营，立足京津冀，致力于打造“互联网+影视”的全新文化项目孵化模式。业务涵盖影视项目策划、影视剧本创作、影视制片制作三大板块。公司长期与中影股份、博纳影业、华视娱乐、华策影视、欢瑞世纪、光线传媒等国内著名影视制作公司合作，致力于原创影视剧本创作及类型化影视项目制作等专业领域的深耕与拓展。</p>
            <p>创始人董哲是业内知名编剧/导演，中国电视艺术家协会会员，北京电视艺术家协会理事，曾获中国电影华表奖、中国电影金鸡奖（提名）、北京影视春燕奖、休斯敦电影节金雷米奖等多项奖项。（下文有作品对应奖项）代表作品有《建党伟业》、《建军大业》、《智取威虎山》、《百团大战》、《一号目标》、《出山》、《天下长安》、《江山纪》、《壮士出川》、《我们的战争》等。</p>
            <p>剧本创作作为北门影视的主营业务，在多年的发展运营中吸引了众多优秀的编剧投稿并签约，积累了大量优质内容，北门中文网因此应运而生。北门中文网目前签约作品近千部，其中待开发优质影视项目达上百部。剧本分类类型化、精细化，包括历史、军事、谍战、言情、科幻、喜剧等数十个专业分类。并从剧本创作之初介入影视策划，对剧本进行全方位审核评估，保障剧本的影视化生产孵化。</p>
        </div>
    </div>
</template>

<script>
export default {
    name:'AboutUs'
}
</script>

<style lang="scss" scoped>
    .about-us{
        padding:50px 35px;
        padding-top:128px;
        .img-box{
            width:678px;
            height:235px;
            margin-bottom:50px;
            img{
                width:330px;
                height:235px;
            }
            img:first-child{
                margin-right:18px;
            }
        }
        p{
            font-size:22px;
            color:#999;
            line-height:36px;
            margin-bottom:48px;
            text-indent:44px;
        }
    }
</style>